/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TAddFavoriteRequest, TAddFavoriteModel, IMappers, TAddFavoriteResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IAddFavoriteResponseSchema } from '../../entities/add_favorite/AddFavoriteResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createAddFavoriteModel(parameters: TAddFavoriteRequest): TAddFavoriteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/add-favorite/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddFavoriteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddFavoriteRequest;
}

export async function fetchAddFavorite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddFavoriteOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAddFavoriteResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddFavoriteModel(parameters),
    config,
  )) as FetchResponse<TAddFavoriteResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFavoriteResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddFavoriteResponse>;
}
